import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from "../../../../../shared/components/button/button.component";
import { ActivatedRoute, Router } from '@angular/router';
import { RoutesPath } from '../../../../../shared/constants/routes-path';
import { Venue } from '../venue.component';
import { VenueData } from '../venus.data';
export interface VenueDetail {
  name: string;
  description: string;
  capacity: number;
  size: number;
  amenities: string;
  memberRate: number;
  nonMemberRate: number;
  images: any;
}
@Component({
  selector: 'app-venue-detail',
  imports: [CommonModule, TranslateModule, ButtonComponent],
  templateUrl: './venue-detail.component.html',
  styleUrl: './venue-detail.component.scss'
})
export class VenueDetailComponent {
  @Input() venue: any;
  @Input() isPopup = false;
  @Output() close = new EventEmitter<void>();
  venues: any = VenueData.list;
  constructor(
    private router: Router,
    private route: ActivatedRoute) {
  }
  slide = 0;
  
 next(): void {
  const length = this.venue?.sliderImages?.length || 0;
  this.slide = (this.slide + 1) % length;
}

prev(): void {
  const length = this.venue?.sliderImages?.length || 0;
  this.slide = (this.slide - 1 + length) % length;
}

  backToVeneusList() {
    if (this.isPopup) {
      this.close.emit();
      return;
    }
    this.router.navigate([`${RoutesPath.SERVICE}/${RoutesPath.VENUE.VENUE_LIST}`]);
  }
}
